export enum RelocationLimitFormMode {
    Create,
    Edit,
}
